<!--
  Copyright (c) MobiFactory. All rights reserved.
  This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
  See LICENSE.txt file in the project root for full license information.
-->

<template>
  <el-select v-model="selectedType" :disabled="hasMultipleTypesEnabled === false">
    <el-option v-if="isProspectEnabled === true" :label="$t('AccountType.2')" :value="accountType.PROSPECT"></el-option>
    <el-option v-if="isCustomerEnabled === true" :label="$t('AccountType.1')" :value="accountType.CUSTOMER"></el-option>
    <el-option v-if="isOtherEnabled === true" :label="$t('AccountType.0')" :value="accountType.OTHER"></el-option>
  </el-select>
</template>

<script>
import { AccountType } from "@/model/AccountType";
import { PermissionAction } from "@/model/Permissions";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CrmAccountTypeSelect",
  props: {
    modelValue: {
      type: Number,
      default: AccountType.PROSPECT,
    },
  },
  emits: ["update:modelValue"],
  /**
   * Gets the component data
   * @returns {object} Component data
   */
  data() {
    return {
      accountType: AccountType,
    };
  },
  computed: {
    selectedType: {
      /**
       * Gets type
       * @returns {number}
       */
      get() {
        return this.modelValue;
      },
      /**
       * Sets the type
       * @param {number} value - new type
       */
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    /**
     * Indicates if the prospect option is enabled.
     * @returns {boolean} true if the prospect option is enabled; false otherwise.
     */
    isProspectEnabled() {
      return this.$accountPermission(AccountType.PROSPECT, PermissionAction.CREATE);
    },
    /**
     * Indicates if the customer option is enabled.
     * @returns {boolean} true if the customer option is enabled; false otherwise.
     */
    isCustomerEnabled() {
      return this.$accountPermission(AccountType.CUSTOMER, PermissionAction.CREATE);
    },
    /**
     * Indicates if the other option is enabled.
     * @returns {boolean} true if the other option is enabled; false otherwise.
     */
    isOtherEnabled() {
      return this.$accountPermission(AccountType.OTHER, PermissionAction.CREATE);
    },
    /**
     * Indicates if multiple options are enabled.
     * @returns {boolean} true if multiple options are enabled; false otherwise.
     */
    hasMultipleTypesEnabled() {
      return (
        (this.isProspectEnabled && this.isCustomerEnabled) ||
        (this.isProspectEnabled && this.isOtherEnabled) ||
        (this.isCustomerEnabled && this.isOtherEnabled)
      );
    },
  },
});
</script>
